import React from 'react';
import PropTypes from 'prop-types';

const Logo = ({ variant = 'primary', className = '' }) => {
  const variants = {
    primary: {
      title: 'text-logo-title',
      subtitle: 'text-logo-subtitle'
    },
    light: {
      title: 'text-logo-title2',
      subtitle: 'text-logo-subtitle2'
    }
  };

  const colors = variants[variant] || variants.primary;

  return (
    <div className={`flex flex-col items-center text-center ${className}`}>
      <h1 className={`mt-2 mr-3 md:mt-3 text-6xl md:text-8xl font-normal tracking-normal font-logo ${colors.title} text-center`}>
        Liad Dahari
      </h1>
      <p className={`text-xs -mt-2.5 md:-mt-5 ml-12 md:ml-20 md:text-xl font-montserrat tracking-widest ${colors.subtitle} text-center`}>
        VOCALIST • VOCAL COACH
      </p>
    </div>
  );
};

Logo.propTypes = {
  variant: PropTypes.oneOf(['primary', 'light']),
  className: PropTypes.string,
};

export default Logo;